import { render, staticRenderFns } from "./TypesImageFeaturesBlock.vue?vue&type=template&id=63d754ce&scoped=true&"
import script from "./TypesImageFeaturesBlock.vue?vue&type=script&lang=js&"
export * from "./TypesImageFeaturesBlock.vue?vue&type=script&lang=js&"
import style0 from "./TypesImageFeaturesBlock.vue?vue&type=style&index=0&id=63d754ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d754ce",
  null
  
)

export default component.exports